import { BrandBadge } from "@/components/BrandBadge";

const items = ["Salesforce", "AWS", "Mulesoft", "IBM", "PMP", "ITIL"];

export default function TrustBar() {
  const track = [...items, ...items];
  return (
    <section data-testid="trust-bar" className="border-y border-slate-200 bg-slate-50/60 py-10 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="text-xs uppercase tracking-widerest text-slate-500 font-mono-plex text-center mb-6">
          Trusted training aligned with industry certifications
        </div>
      </div>
      <div className="relative overflow-hidden">
        <div className="marquee-track flex gap-14 min-w-[200%] items-center">
          {track.map((v, i) => (
            <div key={i} className="flex items-center gap-3 shrink-0">
              <BrandBadge vendor={v} size={36} />
              <span className="font-display font-semibold text-slate-800 text-lg">{v}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
